// @flow

import * as React from 'react';
import staticRedirect from 'utils/staticRedirect';
import __p from 'utils/__p';
import authStore from 'stores/auth';

type Returner = () => void;

const useLogout = (): Returner => React.useCallback(
    () => {
        authStore.logout();
        staticRedirect(__p('/login'), { replace: true });
    },
    []
);

export default useLogout;
